module.exports = __webpack_public_path__ + "img/81.67a92f46.jpg";